import { t } from '@lingui/core/macro'
import React, { useMemo } from 'react'
import { Accordion, Divider } from '@tecsinapse/cortex-react'
import { TriggerAccordion } from './trigger-accordion'
import { FormMultiSelect } from '../../hook-form-connectors/form-multi-select'
import { useCargos } from '@/modules/usuarios-edicao/hooks/use-cargos'

interface AccordionCargosFuncionalidadesProps {
  possuiCargos: boolean
}

export const AccordionCargosFuncionalidades = ({
  possuiCargos
}: AccordionCargosFuncionalidadesProps) => {
  const { cargos = [] } = useCargos()
  const cargosOptions = useMemo(
    () =>
      cargos?.map(cargo => ({
        value: cargo?.id,
        label: cargo?.nome
      })),
    [cargos]
  )

  return cargos && cargos?.length > 0 ? (
    <div className={'mt-deca border border-secondary-light rounded-mili '}>
      <Accordion.Face direction={'vertical'}>
        <TriggerAccordion
          labelCheboxbox={t`Por cargo`}
          idCheckbox={'possuiCargos'}
          value={possuiCargos}
          fieldToClear={'cargos'}
        />
        <Accordion.Content direction={'vertical'}>
          <Divider />
          <div className={'p-deca h-[15rem]'}>
            <div className={'sm:w-[50%]'}>
              <FormMultiSelect
                name='cargos'
                label={t`Cargo`}
                options={cargosOptions}
                withSearch
              />
            </div>
          </div>
        </Accordion.Content>
      </Accordion.Face>
    </div>
  ) : null
}
